import { createBrowserRouter } from "react-router-dom";
import DashboardLayout from "../layout/DashboardLayout";
import Dashboard from "../pages/dashboard/Dashboard";
import Signin from "../pages/auth/Signin";
import Partnership from "../pages/partnership/Partnership";
import Users from "../pages/user/Users";
import Chat from "../pages/chat/Chat";
import SocialMedia from "../pages/SocialMedia/SocialMedia";
import TermsAndCondition from "../pages/TermsAndConditions/TermsAndConditions";
import Setting from "../pages/setting/Setting";
import PrivateRoute from "./PrivateRoute";
import ProtectRoute from "./ProtectRoute";
import ForgotPassword from "../pages/auth/ForgotPassword";
import ResetPassword from "../pages/auth/ResetPassword";
import FAQs from "../pages/faqs/FAQs";
import MerchandiseProducts from "../pages/merchandiseProducts/MerchandiseProducts";
import MerchandiseRequests from "../pages/merchandiseRequests/MerchandiseRequests";
import WalletAdminPage from "../pages/WalletAdminPage/WalletAdminPage";
import ApportunityRequest from "../pages/apportunityRequest/ApportunityRequest";
import MerchandiseCategory from "../pages/MerchandiseCategory/MerchandiseCategory";
import Questionnaire from "../pages/Questionnaire/Questionnaire";
import UserQuestions from "../pages/user/UserQuestions";
import UserPartnerships from "../pages/userPartnerships/UserPartnerships";
import UserGoals from "../pages/userGoals/UserGoals";
import ConfigSettings from "../pages/ConfigSettings/ConfigSettings";
import AdminManagement from "../pages/AdminManagement/AdminManagement";
import PermissionDenied from "../pages/PermissionDenied/PermissionDenied";
import EmailTemplates from "../pages/EmailTemplates/EmailTemplates";
import EmailLogs from "../pages/EmailLogs/EmailLogs";
import MerchandiseSales from "../pages/MerchandiseSales/MerchandiseSales";
import BusinessOpportunity from "../pages/businessOpportunity/BusinessOpportunity";
import AIFeeding from "../pages/aiFeeding/AIFeeding";

const router = createBrowserRouter([
  {
    path: "",
    element: (
      <PrivateRoute>
        {" "}
        <DashboardLayout />
      </PrivateRoute>
    ),
    children: [
      {
        path: "",
        element: <Dashboard />,
      },
      {
        path: "partnership",
        element: <Partnership />,
      },
      {
        path: "users",
        element: <Users />,
      },
      {
        path: "user-questions/:userId",
        element: <UserQuestions />,
      },
      {
        path: "user-goals/:userId",
        element: <UserGoals />,
      },
      {
        path: "merchandiseProducts",
        element: <MerchandiseProducts />,
      },
      {
        path: "merchandiseRequests",
        element: <MerchandiseRequests />,
      },
      {
        path: "merchandiseCategories",
        element: <MerchandiseCategory />,
      },
      {
        path: "merchandiseSales",
        element: <MerchandiseSales />,
      },
      {
        path: "questionnaire",
        element: <Questionnaire />,
      },
      {
        path: "chat",
        element: <Chat />,
      },
      {
        path: "social-media",
        element: <SocialMedia />,
      },
      {
        path: "term_and_conditions",
        element: <TermsAndCondition />,
      },
      {
        path: "faqs",
        element: <FAQs />,
      },
      {
        path: "setting",
        element: <Setting />,
      },
      {
        path: "config-settings",
        element: <ConfigSettings />,
      },
      {
        path: "email-templates",
        element: <EmailTemplates />,
      },
      {
        path: "email-logs",
        element: <EmailLogs />,
      },
      {
        path: "adminWallet",
        element: <WalletAdminPage />,
      },
      {
        path: "opportunity-request",
        element: <ApportunityRequest />,
      },
      {
        path: "user-partnerships",
        element: <UserPartnerships />,
      },
      {
        path: "admin-management",
        element: <AdminManagement />,
      },
      {
        path: "ai-feeding",
        element: <AIFeeding />,
      },
      {
        path: "permission-denied",
        element: <PermissionDenied />,
      },
    ],
  },
  {
    path: "/permission-denied",
    element: <PermissionDenied />,
  },
  {
    path: "/signin",
    element: (
      <ProtectRoute>
        {" "}
        <Signin />
      </ProtectRoute>
    ),
  },
  {
    path: "/forgetPassword",
    element: (
      <ProtectRoute>
        {" "}
        <ForgotPassword />{" "}
      </ProtectRoute>
    ),
  },
  {
    path: "/reset-password",
    element: (
      <ProtectRoute>
        {" "}
        <ResetPassword />{" "}
      </ProtectRoute>
    ),
  },
  {
    path: "/business/opportunity/:id",
    element: <BusinessOpportunity />,
  },
  {
    path: "/business/opportunity",
    element: <BusinessOpportunity />,
  },

  // {
  //     path: '/otp-verification',
  //     element:<ProtectRoute> <OtpVerification /> </ProtectRoute>
  // },
  // {
  //     path: '/email-verification',
  //     element: <ProtectRoute> <EmailVerification /></ProtectRoute>
  // },
  // {
  //     path: '/new-password',
  //     element: <ProtectRoute><NewPassword /></ProtectRoute>
  // },
]);

export default router;
